// @ts-nocheck
import styled from 'styled-components'
import React, { useEffect, useRef, memo } from 'react'

const Page = styled.div`
  max-width: 1160px;
  margin-top: 40px;
  font-family: 'Inter var', sans-serif;
  padding: 0 20px;
  /* min-height: 900px; */
  /* min-height: 78vh; */
  @media (max-width: 768px) {
    margin-top: 100px;
    width: 100%;
    padding: 16px;
  }
`
const Advertising = styled.div`
  font-size: 16px;
  line-height: 1.8;
  padding-bottom: 10px;
`
export default function TradingViewWidget() {
  const container = useRef()

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js'
    script.type = 'text/javascript'
    script.async = true
    script.innerHTML = `
        {
          "symbols": [
            [
              "BYBIT:BTCUSDT|1M"
            ],
            [
              "BINANCE:ETHUSDT|1M|XTVCBTC"
            ],[
              "BINANCE:ETHBTC|1M|XTVCBTC"
            ]

          ],
          "chartOnly": false,
          "width": "100%",
          "height": "620",
          "locale": "en",
          "colorTheme": "light",
          "autosize": true,
          "showVolume": false,
          "showMA": false,
          "hideDateRanges": false,
          "hideMarketStatus": false,
          "hideSymbolLogo": false,
          "scalePosition": "right",
          "scaleMode": "Normal",
          "fontFamily": "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
          "fontSize": "10",
          "noTimeScale": false,
          "valuesTracking": "1",
          "changeMode": "price-and-percent",
          "chartType": "area",
          "maLineColor": "#2962FF",
          "maLineWidth": 1,
          "maLength": 9,
          "headerFontSize": "medium",
          "lineWidth": 2,
          "lineType": 0,
          "dateRanges": [
            "1m|30",
            "3m|60",
            "12m|1D",
            "60m|1W",
            "all|1M"
          ]
        }`
    container.current.appendChild(script)
  }, [])

  
  return (
    <Page>
      <h1>DovraSwap Integrates TradingView to Enhance Trading Experience</h1>
      <Advertising>
        DovraSwap has now applied for integration with TradingView, bringing more intuitive charts and technical
        analysis tools to users. Through this collaboration, users will be able to: <br />
        1.Real-Time Market Analysis
        <br />
        Utilize TradingView’s professional candlestick charts and technical indicators to easily track cryptocurrency
        price movements and optimize trading strategies. For example, using the{' '}
        <a href="https://www.tradingview.com/symbols/BTCUSD/">BTC/USD</a> price trend chart, users can clearly
        understand the price fluctuations and market dynamics of various cryptocurrencies, helping them make more
        strategic trading decisions.
        <br />
        2.Backtesting Functionality
        <br />
        Simulate trading decisions with historical data, allowing users to optimize strategies and improve their
        investment returns. <br />
        3.Seamless Experience
        <br />
        In the future, users will be able to directly use TradingView tools within the DovraSwap trading interface,
        eliminating the need to switch platforms, making operations more efficient and convenient. If this integration
        with TradingView is successfully achieved, DovraSwap will be able to offer smarter and more convenient trading
        support to its users.
      </Advertising>
      <div className="tradingview-widget-container" ref={container}>
        <div className="tradingview-widget-container__widget"></div>
        {/* <div className="tradingview-widget-copyright">
          <a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank">
            <h2 className="blue-text">Track all markets on TradingView</h2>
          </a>
        </div> */}
      </div>
    </Page>
  )
}
